import LearnPageLayout from "@/components/LearnPageLayout";
import { page3 } from "./learnDataP3";

const AcceleratedTmsPage = () => (
  <LearnPageLayout
    title={page3.title}
    description={page3.description}
    canonical={page3.canonical}
    h1={page3.h1}
    breadcrumbLabel={page3.breadcrumbLabel}
    crumbs={page3.crumbs}
    shortAnswer={page3.shortAnswer}
    keyTakeaways={page3.keyTakeaways}
    sections={page3.sections}
    faqs={page3.faqs}
    sources={page3.sources}
    schemaJson={page3.schemaJson}
    relatedLinks={page3.relatedLinks}
  />
);

export default AcceleratedTmsPage;
